export default __webpack_public_path__ + "static/media/delete-red.08021509.svg";